/**
 * @description Component-SearchPair
 */
import './index.less';

import { default as classNames } from 'classnames';
import React, { FC, ReactNode, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PAIR_PAGE_TYPE, TRADE_LEVERAGE_THRESHOLDS } from '@/constants/global';
import { useChainId } from '@/hooks/web3/useChain';

import DropDownIcon from '@/assets/svg/dropdown.svg?react';
import { mockOpenDropdown } from '@/constants/mock';
import { useCurrentMarketPairFromUrl, useMarketList } from '@/features/market/hooks';
import TradingPairs from '@/pages/Market/TradingPairs';
import { usePairCheck } from '@/pages/components/PairInfo/pairCheckHook';
import _ from 'lodash';
import { Button } from '../Button';
import Dropdown from '../Dropdown';
import TokenPair from '../TokenPair';
interface IPropTypes {
  type: PAIR_PAGE_TYPE;
  createOnly?: boolean;
  tagExtra?: ReactNode;
}
const SearchPair: FC<IPropTypes> = function ({ createOnly, type }) {
  const chainId = useChainId();
  const { t } = useTranslation();
  const currentPairBaseInfo = useCurrentMarketPairFromUrl(chainId);

  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  // const { isExtraLarge } = useMediaQueryDevice();

  const { marketPairList } = useMarketList(chainId);

  usePairCheck(chainId, currentPairBaseInfo?.symbol, [...(marketPairList || []).map((p) => p.symbol)], type);

  return (
    <div className="syn-pair-selector-container">
      <Dropdown
        align={{
          offset: [0, 8],
        }}
        // disabled={isExtraLarge}
        trigger={['click']}
        withPadding={false}
        overlayClassName="syn-pair-selector-overlay"
        onOpenChange={(open) => {
          !mockOpenDropdown && setShowPopup(open);
        }}
        open={showPopup}
        getPopupContainer={() => {
          return popupRef.current as HTMLElement;
        }}
        dropdownRender={() => <TradingPairs onClose={() => setShowPopup(false)} />}>
        <div className="syn-pair-selector">
          {/* {isExtraLarge && <ShowPairsBtn />} */}
          {createOnly ? (
            <Button type="text">{t('common.market.newP')}</Button>
          ) : (
            <div className="syn-pair-selector-fixed">
              {/* // For menu go left */}
              <div style={{ width: 12, height: 16 }} />
              <div className="syn-pair-symbol">
                {currentPairBaseInfo && (
                  <TokenPair
                    showMarginText
                    requiredMarginIcon={false}
                    tokenSize={32}
                    baseToken={currentPairBaseInfo.baseToken}
                    quoteToken={currentPairBaseInfo.quoteToken}
                    isInverse={false}
                    expiry={currentPairBaseInfo?.expiry}
                    verticalMode={true}
                    showFavorite={!!_.get(currentPairBaseInfo, 'instrumentAddr', false)}
                    instrumentAddr={_.get(currentPairBaseInfo, 'instrumentAddr', '') || ''}
                    showLeverage={true}
                    chainId={currentPairBaseInfo?.chainId}
                    dropdownIcon={
                      // !isExtraLarge && (
                      <DropDownIcon
                        className={classNames(showPopup ? 'rotate' : '', 'syn-pair-selector-fixed-drop-icon')}
                      />
                      // )
                    }
                    isShowExpiryTag
                    leverage={currentPairBaseInfo?.maxLeverage || TRADE_LEVERAGE_THRESHOLDS.MAX}
                    showShortPerp={true}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </Dropdown>
      {/* <div ref={popupRef} className="syn-pair-selector-popup-container" /> */}
    </div>
  );
};

export default React.memo(SearchPair);
